const MONTHS = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];

function parseIsoDate(iso: string): {
  day: number;
  month: number;
  year: number;
} {
  const parts = iso.split("-").map(Number);
  const year = parts[0] ?? 0;
  const month = parts[1] ?? 1;
  const day = parts[2] ?? 1;
  return { day, month: month - 1, year };
}

/** "25/09-2026" */
export function formatInvoiceDate(iso: string): string {
  const { day, month, year } = parseIsoDate(iso);
  return `${String(day).padStart(2, "0")}/${String(month + 1).padStart(2, "0")}-${year}`;
}

/** "25 September 2026" */
export function formatLongDate(iso: string): string {
  const { day, month, year } = parseIsoDate(iso);
  return `${day} ${MONTHS[month]} ${year}`;
}

/** "01/09-2026 s/d 25/09-2026" */
export function formatPeriod(startIso: string, endIso: string): string {
  return `${formatInvoiceDate(startIso)} s/d ${formatInvoiceDate(endIso)}`;
}
